import React, {Component} from 'react';
import '../App.css';
import axios from 'axios';

class ForgotPwd extends Component{
    //call the constructor method
    constructor(props){
        super(props);
        
        this.state = {
            useremail : "",
            message: "",
            authFlag : false
        }

        //Bind the handlers to this class
        this.useremailChangeHandler = this.useremailChangeHandler.bind(this);
        this.submitForgotPwd = this.submitForgotPwd.bind(this);
    }
    //Call the Will Mount to set the auth Flag to false
    componentWillMount(){
        this.setState({
            authFlag : false
        })
    }
    
    useremailChangeHandler = (e) => {
        this.setState({
            useremail : e.target.value
        })
    }
    
    handleValidation(){
        let formIsValid = true;

        //useremail
        if(!this.state.useremail){
            formIsValid = false;
            this.setState({
                message : "Useremail is a Required field."
            });
        }
        
        return formIsValid;
   }

    switchPopupSignup = (e) => {
        e.preventDefault();
        this.props.switchPopupSignup();
    }
    
    submitForgotPwd = (e) => {
        e.preventDefault();

        if(this.handleValidation()){
            const data = {
                useremail : this.state.useremail                
            }
            //set the with credentials to true
            axios.defaults.withCredentials = true;
                        
            axios.post(window.$backend_url + '/forgotpassword',data)
                .then(response => {
                    if(response.status === 200){
                        this.props.closeForgotPwdPopup();
                    }
                })
                .catch(error => {
                    this.setState({
                        message : "The useremail is not available."
                    });
                })
        }
    }

    render(){
        return(            
            <div className="custom-modal">
                <div className="modal-logo">
                    <img alt="logo" src="/assets/images/logo.png" />
                </div>
                <h2 className="text-center">{this.props.dataLanguage['forgotPwd']}</h2>
                <form className="forgot-pwd-form">
                    { this.state.message ?
                        <p className="message-text">{ this.state.message }</p>
                    : null }
                    <div className="form-group">
                        <label>{this.props.dataLanguage['email']}</label>
                        <div className="user-container">
                            <input onChange = {this.useremailChangeHandler} type="email" className="form-control useremail" name="useremail" ></input>
                        </div>
                    </div>
                    <button onClick = {this.submitForgotPwd} type="submit" className="btn-submit">{this.props.dataLanguage['recoverPwd']}</button>
                    <div className="text-center">
                        <span className="other-link">{this.props.dataLanguage['forgotPwd_msg']}</span>
                    </div>
                </form>
                <div className="text-center">
                    <span className="other-link">{this.props.dataLanguage['dontAccount']} <a href="" className="link-yellow" onClick={this.switchPopupSignup}>{this.props.dataLanguage['signup']}</a></span>
                </div>
            </div>
        )
    }
}

export default ForgotPwd;


// WEBPACK FOOTER //
// ./src/components/ForgotPwd.js